export default "__VITE_ASSET__3d8K8X00__"